import React, {useEffect, useState, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {inject, observer} from "mobx-react";
//local
import {Info} from "components/Info";
import {Layout} from "components/UI/layout";
import {IconList} from "components/icons";
import QualificationsTableHead from "./components/QualificationsTableHead";
import {Preloader} from "components/Preloader";
import {defaultNameFieldSearch} from "constants/user.consts";
import QualificationsTableItem from "./components/QualificationsTableItem";
import {QualificationAnswersModal} from "components/modals/QualificationAnswersModal";
import EmptyData from "components/EmptyData";
import {useSavedFilters} from "helpers/userHooks";
import {changeFilterParams} from "helpers/helper";
import {color} from "constants/color.consts";

const OurQualificationsPage = inject("store")(
  observer(({store: {auth, clientStore}}) => {
    const {t} = useTranslation();
    const {isStaff} = auth;

    const [qualifications, setQualifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [qualification, setQualification] = useState(null);
    const [loadingQualificationId, setLoadingQualificationId] = useState(null);

    const [filters, setFilter] = useSavedFilters({
      key: "ourQualificationsPageFilter",
      defaultValue: defaultNameFieldSearch,
    });

    const getQualificationAnswersList = useCallback(() => {
      setLoading(true);
      clientStore
        .getQualificationAnswersList(filters)
        .then(({data}) => setQualifications(data))
        .finally(() => setLoading(false));
    }, [clientStore, filters]);

    const onChangeOrder = (value) =>
      setFilter({...filters, ...changeFilterParams(value)});

    const handleShowQualificationAnswersModal = (id) => {
      setLoadingQualificationId(id);
      clientStore
        .getQualificationAnswers(id, "seller")
        .then(({data}) =>
          setQualification({
            ...data,
            questions: data.questions.map((question) => ({
              ...question,
              files: question.files?.map((file) => ({...file, ...file.File})),
            })),
            answers: data.answers
              ? data.answers.map((answer) => ({
                  ...answer,
                  files: answer.files?.map((file) => ({...file, ...file.File})),
                }))
              : [],
          })
        )
        .finally(() => setLoadingQualificationId(null));
    };

    useEffect(() => {
      getQualificationAnswersList();
    }, [getQualificationAnswersList]);

    return (
      <Layout>
        <div className="our-qualifications">
          <div className="content-block_header">
            <IconList color={color.black} />
            <h3 className="content-block_title __uppercase">
              {t("OUR_SUPPLIER_QUALIFICATIONS")}
            </h3>
            <Info
              tooltip="OUR_SUPPLIER_QUALIFICATIONS_PAGE_INFO_TOOLTIP"
              centerText
              addClass="ml-4"
            />
          </div>
        </div>
        <div className="our-qualifications content-block_wrapper">
          <QualificationsTableHead onChangeOrder={onChangeOrder} filters={filters} />
          {loading ? (
            <Preloader addClass="preloader250" />
          ) : (
            <React.Fragment>
              {qualifications.length ? (
                qualifications.map((qualification) => (
                  <QualificationsTableItem
                    key={qualification.id}
                    qualification={qualification}
                    loadingId={loadingQualificationId}
                    showQualificationAnswers={handleShowQualificationAnswersModal}
                  />
                ))
              ) : (
                <EmptyData addClass={`empty-data pt-4`} />
              )}
            </React.Fragment>
          )}
        </div>
        {qualification && (
          <QualificationAnswersModal
            initialQualification={qualification}
            isAdminOwner={isStaff}
            onClose={(values) => {
              values?.needUpdateAnswers && getQualificationAnswersList();
              setQualification(null);
            }}
          />
        )}
      </Layout>
    );
  })
);

export default OurQualificationsPage;
